import React from 'react';
import { Link } from 'react-router-dom';

// Document section component with authentication handling
const DocumentSection = ({ documents, isAuthenticated, t }) => {
    if (!documents || Object.values(documents).every(doc => !doc)) {
        return null;
    }

    return (
        <div className="bg-gray-50 rounded-xl p-6">
            <div>
                <div>
                    <h2 className="text-2xl font-semibold mb-6">{t('estate.details.documents.title')}</h2>

                    {!isAuthenticated && (
                        <div className="mb-6 p-4 bg-sky-50 border border-sky-200 rounded-lg">
                            <p className="text-sm text-sky-800 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mr-2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                </svg>
                                {t('estate.details.documents.loginRequired')}
                            </p>
                        </div>
                    )}

                    <div className="gap-8 grid grid-cols-2">
                        {Object.entries(documents).map(([key, value]) => {
                            if (!value) return null;

                            const DocumentLink = isAuthenticated
                                ? 'a'
                                : Link;

                            return (
                                <div className="w-full" key={key}>
                                    <DocumentLink
                                        href={isAuthenticated ? value : undefined}
                                        to={!isAuthenticated ? '/register' : undefined}
                                        target={isAuthenticated ? "_blank" : undefined}
                                        rel={isAuthenticated ? "noopener noreferrer" : undefined}
                                        className="flex items-center p-3 bg-white rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-gray-500 mr-3">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                                        </svg>

                                        <div className="flex-grow">
                                            <p className="text-sm font-medium text-gray-900">
                                                {t(`estate.details.documents.types.${key}`)}
                                            </p>
                                            <p className="text-xs text-gray-500">PDF</p>
                                        </div>

                                        {isAuthenticated ? (
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-gray-400">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                                            </svg>
                                        ) : (
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-red-400">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
                                            </svg>
                                        )}
                                    </DocumentLink>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocumentSection;